import React, { useRef } from 'react';
import { Filter } from 'pepsico-ds';
import type {
  FilterProps,
  IFilterHandle,
} from 'pepsico-ds/dist/lib/Molecules/Filter/types';
import styled from 'styled-components';

export interface FilterWrapperProps extends Omit<FilterProps, 'isDark'> {
  maxWidth?: string;
}

const StyledFilterWrapper = styled.div`
  width: inherit;
  /* Logic:
     1. Look inside .menu-list
     2. If it does NOT (:not) contain (:has) a .tag
     3. Then disable the Apply button
  */
  .menu-list:not(:has(.tag))
    .menu-list-footer
    .button-hierarchy-right
    button:last-child {
    opacity: 0.5;
    pointer-events: none;
    cursor: not-allowed;
  }

  /* Prevent the count tag from being clickable and hide the close button */
  .filter .tag {
    pointer-events: none;
    cursor: default;

    /* Hide the close button */
    .base-button {
      display: none;
    }
  }
`;
const FilterWrapperBase = React.forwardRef<IFilterHandle, FilterWrapperProps>(
  (
    {
      options,
      value,
      onChange,
      maxWidth = 'none',
      menuPosition = 'bottom-left',
      controlled = true,
      style = {},
      showSearch = false,
      selection = 'single', //"date","single","multiple","dateRange"
      isClearable = false,
      ...rest
    },
    ref
  ) => {
    const callbackRef = useRef(onChange);
    callbackRef.current = onChange;

    // Create a stable callback function that won't change on every render
    const handleChange = React.useCallback(
      (val: any) => {
        callbackRef.current?.(val);

        // Automatically close the filter menu after selection if needed
        setTimeout(() => {
          if (ref && 'current' in ref && ref.current?.closeMenu) {
            ref.current.closeMenu();
          }
        }, 0);
      },
      [ref]
    );

    return (
      <StyledFilterWrapper>
        <Filter
          options={options}
          value={value}
          onChange={handleChange}
          ref={ref}
          style={{ width: '100%', maxWidth: maxWidth, ...style }}
          controlled={controlled}
          menuPosition={menuPosition}
          showSearch={showSearch}
          selection={selection}
          isClearable={isClearable}
          {...rest}
        />
      </StyledFilterWrapper>
    );
  }
);

FilterWrapperBase.displayName = 'FilterWrapper';

export default FilterWrapperBase;
